import config from "../../config/config";
import connection from "../../utils/connection";

const getMenues = async () => {
  let response = {};
  try {
    const responseGet = await connection({
      method: "GET",
      url: "/menu/buscar",
    });
    if (responseGet.status === 401) return (window.location.href = `${config.URL.STOP_APP_URL}/login`);
    response = responseGet;
  } catch (error) {
    console.error("catch service", error);
    response = error.response;
  }

  return response;
};

export default getMenues;
